enum QuestionCategoryEnum {
    IPE = "IPE",
    PE = "PE",
    ADVERSARIAL = "ADVERSARIAL",
    TECHNIQUE = "TECHNIQUE",
    ARCHITECTURE = "ARCHITECTURE",
}


export default QuestionCategoryEnum;